import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { MouseEventHandler, useState } from 'react'

import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { usePrivateAction } from '@/lib/privateAction'

type ButtonCellProps = {
  onSubmit: MouseEventHandler<HTMLButtonElement>
  disabled: boolean
  isSubmitting: boolean
}
export const ButtonCell: Cell<ButtonCellProps> = ({
  onSubmit,
  disabled,
  isSubmitting,
}) => {
  const { t } = useTranslation('lotteryDetail')
  const { handleLoginModal } = usePrivateAction()
  const [checked, setChecked] = useState<boolean>(false)
  const { router } = useRouter()

  return (
    <CellFrame sx={{ py: 4 }}>
      <Stack spacing={4} alignItems="center">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onClick={handleLoginModal(() =>
                setChecked(prevState => !prevState)
              )}
            />
          }
          label={
            <Typography variant="caption" color="text.secondary">
              {t('checkBoxLabel')}
            </Typography>
          }
        />
        <Button
          size="large"
          disabled={!checked || disabled}
          loading={isSubmitting}
          sx={{ width: 212 }}
          onClick={handleLoginModal(onSubmit)}
        >
          {t('submit')}
        </Button>
        <Button
          variant="text"
          size="small"
          sx={{ width: 212 }}
          onClick={() => router.goBack()}
        >
          {t('back')}
        </Button>
      </Stack>
    </CellFrame>
  )
}
